import { API_BASE } from "config/api";
import { withAuthHeaders } from "services/authHeader";
import { apiFetch } from "services/apiFetch";

function jsonHeaders() {
  return withAuthHeaders({
    "Content-Type": "application/json",
    Accept: "application/json",
  });
}

export async function getAllCrls() {
  try {
    const url = new URL("api/crls", API_BASE);
    const res = await apiFetch(url, {
      method: "GET",
      headers: jsonHeaders(),
    });
    const result = await res.json();
    if (result.status === "success") {
      return result.data || [];
    }
    throw new Error(result.message || "Failed to fetch CRLs");
  } catch (error) {
    console.error("Error in getAllCrls:", error);
    throw error;
  }
}

export async function getAllCrlsIncludingDeleted() {
  try {
    const url = new URL("api/crls/all", API_BASE);
    const res = await apiFetch(url, {
      method: "GET",
      headers: jsonHeaders(),
    });
    const result = await res.json();
    if (result.status === "success") {
      return result.data || [];
    }
    throw new Error(result.message || "Failed to fetch CRLs");
  } catch (error) {
    console.error("Error in getAllCrlsIncludingDeleted:", error);
    throw error;
  }
}

export async function getCrlById(id) {
  try {
    const url = new URL(`api/crls/${id}`, API_BASE);
    const res = await apiFetch(url, {
      method: "GET",
      headers: jsonHeaders(),
    });
    const result = await res.json();
    return result;
  } catch (error) {
    console.error("Error in getCrlById:", error);
    throw error;
  }
}

export async function addCrl(formObj) {
  try {
    const url = new URL("api/crls", API_BASE);
    const res = await apiFetch(url, {
      method: "POST",
      headers: jsonHeaders(),
      body: JSON.stringify(formObj),
    });
    return await res.json();
  } catch (error) {
    console.error("Error in addCrl:", error);
    throw error;
  }
}

export async function editCrl(id, formObj) {
  try {
    const url = new URL(`api/crls/${id}`, API_BASE);
    const res = await apiFetch(url, {
      method: "PATCH",
      headers: jsonHeaders(),
      body: JSON.stringify(formObj),
    });
    return await res.json();
  } catch (error) {
    console.error("Error in editCrl:", error);
    throw error;
  }
}

export async function deleteCrl(id) {
  try {
    const url = new URL(`api/crls/${id}/delete`, API_BASE);
    const res = await apiFetch(url, {
      method: "PATCH",
      headers: jsonHeaders(),
    });
    return await res.json();
  } catch (error) {
    console.error("Error in deleteCrl:", error);
    throw error;
  }
}

export async function resetCrlPassword(id, newPassword) {
  try {
    const url = new URL(`api/crls/${id}/reset-password`, API_BASE);
    const res = await apiFetch(url, {
      method: "PATCH",
      headers: jsonHeaders(),
      body: JSON.stringify({ new_password: newPassword }),
    });
    return await res.json();
  } catch (error) {
    console.error("Error in resetCrlPassword:", error);
    throw error;
  }
}
